var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBadged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.453,
    height: 21.305,
    viewBox: "0 0 20.453 21.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell-solid-badged",
    transform: "translate(-4.067 -1.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M22.142,44.126a1.709,1.709,0,0,0,1.652-1.46H20.427a1.709,1.709,0,0,0,1.716,1.46Z",
    transform: "translate(-8.505 -21.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M23.144,19.238l-.218-.192a9.2,9.2,0,0,1-1.607-1.876,8.085,8.085,0,0,1-.864-3.079V10.929a6.99,6.99,0,0,0-.1-1.146,4.8,4.8,0,0,1-3.835-4.712v-.4a6.767,6.767,0,0,0-2.125-.64V3.221a.855.855,0,1,0-1.709,0V4.06A6.92,6.92,0,0,0,6.73,10.929v3.162a8.085,8.085,0,0,1-.864,3.079,9.218,9.218,0,0,1-1.581,1.876l-.218.192v1.805H23.144Z",
    transform: "translate(0 -0.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 3.201,
    cy: 3.201,
    r: 3.201,
    transform: "translate(18.118 1.333)",
    fill: "#e1007f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBadged);
export default __webpack_public_path__ + "static/media/notificationBadged.c8685eac7abe55bf032e570ea654b008.svg";
export { ForwardRef as ReactComponent };